export class Controller {

    /** @ngInject */
    constructor() {
    }

    $onInit() {
        this.methods = 'otp';
    }

    showWidget() {
        const params = this.methods.split('&').map(method => `${method}Supported=true`).join('&');
        this.widgetUrl = `widget.html?${params}&applicationID=${this.appId}`;
        this.widgetUrlDisplay = `${window.env.urls.customAppWidgetIframePrefix}${this.widgetUrl}`;
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/integration-developers/widgets/widgets.controller.js